import { type FC } from 'react'
import { type CharityCampaign } from '@shamaazi/mytennights'
import { EmailSubscriber } from '~/components'
import { isCampaignOpen } from '~/service/activeCampaign'
import { Explainer } from '~/components/Explainer'
import SplitMTD from '~/components/SplitMTD'
import HeadingBG from '~/assets/Heading bg.png'
import { CharityLogo } from '../CharityLogo'
interface Props {
  loading: boolean
  isError: boolean
  charity: CharityCampaign | undefined
  nextPage: string
  notFound: boolean
}

const Charity: FC<Props> = ({ loading, isError, charity, nextPage, notFound }) => {
  if (loading) {
    return <h2 className="heading-lg">Loading...</h2>
  }

  if (isError && !notFound) {
    return <h2 className="heading-lg">Error</h2>
  }

  return <main>
    <div className="flex flex-col">
      <div className="space-y-10 items-center bg-no-repeat bg-cover h-5/6 md:h-full bg-center p-10 md:px-2 md:py-6" style={{ backgroundImage: `url(${HeadingBG})` }}>
        <div className="min-w-screen w-full py-2 flex flex-col items-center px-2">
        <div>
        {<CharityLogo charity={charity} />}
            {notFound && <h3 className="heading-xl">We are sorry but this charity is not available</h3>}
          </div>
        <h1 className={'text-center text-mtd-secondary-4 text-mtd-h1 font-bold leading-10 mt-16'}>Never Miss The 10 Days of Dhul Hijjah</h1>
            {isCampaignOpen() && <SplitMTD nextPage={nextPage}/>}
          {!isCampaignOpen() && <div className={'min-w-screen bg-mtd-blue-100 text-white w-full py-2 flex flex-col items-center px-2'}>
            <p>Get a reminder to automate your donations next Hajj</p>
            <EmailSubscriber />
          </div>}
          <div className='mt-16 md:mt-12 self-center text-center text-mtd-h4 font-normal text-mtd-secondary-4'>"There are no days during which righteous deeds are more</div>
      <div className='self-center text-center text-mtd-h4 font-normal text-mtd-secondary-4'>beloved to Allah than these (first) ten days of Dhul- Hijjah."</div>
      <div className='mt-2 mb-10 justify-center text-mtd-info font-normal text-mtd-secondary-3'>– Prophet Muhammad PBUH [Al-Bukhari]</div>
        </div>
      </div>
      <Explainer />
    </div>
  </main>
}

export default Charity
